import {AfterViewInit, Component, ElementRef, OnInit, Renderer} from '@angular/core';
import {Router} from '@angular/router';
import {EventManager, JhiLanguageService} from 'ng-jhipster';
import {TranslateService} from 'ng2-translate';

import {Principal, StateStorageService} from '../../shared';
import {LoginService} from './login.service';
import {Response} from '@angular/http';
import {ParametrageService} from '../../entities/parametrage';

@Component({
    selector: 'jhi-login',
    templateUrl: './login.component.html'
})
export class JhiLoginComponent implements OnInit, AfterViewInit {
    authenticationError: boolean;
    password: string;
    rememberMe: boolean;
    email: string;
    credentials: any;
    parametrage: any;
    currentLang: string;

    constructor(
        private eventManager: EventManager,
        private languageService: JhiLanguageService,
        private loginService: LoginService,
        private stateStorageService: StateStorageService,
        private elementRef: ElementRef,
        private renderer: Renderer,
        private principal: Principal,
        private router: Router,
        private parametrageService: ParametrageService,
        private translate: TranslateService,

    ) {
        this.languageService.setLocations(['global', 'login'])  ;
        this.credentials = {};
    }

    ngOnInit() {
        this.parametrageService.queryPageEspaceConnexion().subscribe(
            (res: Response) => {
                this.parametrage = this.parametrageService.parametresArrayToObject(res.json());
            });
        this.currentLang = '' + this.languageService.currentLang;
        this.translate.onLangChange.subscribe(lang => this.currentLang = lang.lang);

    }

    ngAfterViewInit() {
        this.renderer.invokeElementMethod(this.elementRef.nativeElement.querySelector('#email'), 'focus', []);
    }

    cancel () {
        this.credentials = {
            email: null,
            password: null,
            rememberMe: true
        };
        this.authenticationError = false;
    }

    login () {
        this.loginService.login({
            email: this.email,
            password: this.password,
            rememberMe: this.rememberMe
        }).then(() => {
            this.authenticationError = false;
            if (this.router.url === '/register' || this.router.url === '/activate' ||
                this.router.url === '/finishReset' || this.router.url === '/requestReset') {
                this.router.navigate(['']);
            }

            this.eventManager.broadcast({
                name: 'authenticationSuccess',
                content: 'Sending Authentication Success'
            });

            // // previousState was set in the authExpiredInterceptor before being redirected to login modal.
            // // since login is succesful, go to stored previousState and clear previousState
            let previousState = this.stateStorageService.getPreviousState();
            if (previousState) {
                this.stateStorageService.resetPreviousState();
                this.router.navigate([previousState.name], { queryParams:  previousState.params });
            }
            this.principal.rootUrl().then(rootUrl => {
                this.router.navigate([rootUrl]);
            });
        }).catch(() => {
            this.authenticationError = true;
        });
    }

    register () {
        this.router.navigate(['/register']);
    }

    requestResetPassword () {
        this.router.navigate(['/reset', 'request']);
    }

    getConnexionMessage(langue: String): String {
        if (langue && langue === 'en') {
            return this.parametrage.MESSAGE_CONNEXION.libelleEn;
        } else {
            return this.parametrage.MESSAGE_CONNEXION.libelle;
        }
    }

}



// WEBPACK FOOTER //
// ./src/main/webapp/app/account/login/login.component.ts